// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1AGp3","footer":"ModalInfo_footer__uL5DK"};